const Auth = {}// 登录、注册、忘记密码
const shop = {} // 商品详情
const sales = {} // 销售统计
const special = {} // 普莱柯专场
const healthy = {}  // 健康管理
const order = {}  // 健康管理
const live = {} // 直播
const chat = {} // 聊天室
const expert = {} // 组方
const apis = '/saas/api/v1'// 本地使用l
let api
let apiII
let appkey
let apiUrl = 'api.sslab.com.cn'
if (apiUrl.includes('api.sslab.com.cn')) {
  api = 'http://api.sslab.com.cn'
  apiII = 'https://app2.sslab.com.cn'
  appkey = 'pwe86ga5pv336'
} else {
  api = 'http://testapi.sslab.com.cn'
  apiII = 'http://59.110.167.93'
  appkey = 'ik1qhw09ipccp'
}
let shareUrl = encodeURIComponent(window.location.href.split('#')[0]);
// console.log('shareUrl',shareUrl)

const api2 = 'http://api.sslab.com.cn'// 本地使用l

// 省接口
Auth.province = { url: apis + '/customer/province', method: 'post' }
// 市接口
Auth.city = { url: apis + '/customer/city', method: 'post' }
// 获取验证码
Auth.sendCode = { url: api + '/custer/user/sendCode', method: 'post' }
// 获取加密的验证码
Auth.vtSendCode = { url: api + '/sso/user/common/vtSendCode', method: 'post' }
// 注册
Auth.register = { url: api + '/custer/activity/register', method: 'post' }
// 微信分享
Auth.wxShare = { url: api + '/custer/wx/signature?link=' + shareUrl, method: 'get' }

// 普通商品详情页接口
shop.shopGeneral = { url: api + '/custer/common/vt/good/detail/general', method: 'post' }
// 品牌闪购商品详情页
shop.shopLimitBuy = { url: api + '/custer/common/vt/good/detail/limitBuy', method: 'post' }
// 新品首发商品详情页
shop.shopNewGoods = { url: api + '/custer/common/vt/good/detail/newGoods', method: 'post' }
// 秒杀商品详情页
shop.shopSeckill = { url: api + '/custer/common/vt/good/detail/seckill', method: 'post' }
// 联免组合详情页
shop.shopCombination = { url: api + '/custer/cus/goods/package/vt/detail/h5', method: 'get' }
// 优惠券接口
shop.shopEnable = { url: api + '/custer/coupon/vt/good/enable', method: 'post' }


// 统计报告
sales.countReport = { url: api + '/salesman/salesCount/countReport', method: 'postdata' }
// 查看范围
sales.getOrganizeTree = { url: api + '/salesman/dept/getOrganizeTree', method: 'postdata' }
// 莱客云个人统计
sales.CountPersonalReport = { url: api + '/salesman/salesCount/countPersonalReport', method: 'postdata' }
// 莱客云个人统计 获取用户信息
sales.getUserInfo = { url: api + '/salesman/user/userInfo', method: 'postdata' }


//健康管理商品猪阶段
healthy.GetStageReport = { url: api + '/health/fpd/getStageReport', method: 'postsyscode' }
//健康管理商品猪周期 
healthy.GetWholeReport = { url: api + '/health/fpd/getWholeReport', method: 'postsyscode' }
//健康管理种猪获取单个档案的阶段报告
healthy.GetBreedingReport = { url: api + '/health/bpd/getBreedingReport', method: 'postsyscode' }
//健康管理种猪获取胎次报告
healthy.GeBreedingRotateReport = { url: api + '/health/bpd/geBreedingRotateReport', method: 'postsyscode' }
//健康管理种猪报告添加头数
healthy.AddBpNumOfReport = { url: api + '/health/bpd/addBpNumOfReport', method: 'postsyscode' }

// 普莱柯专场
special.specialList = { url: api + '/custer/vt/marketingactivities/common/getPsLimitTimeBuyListByLtbId', method: 'post' }

// 好兽药订单详情
order.orderDetail = { url: api + '/custer/center/order/h5/detail', method: 'post' }

// 直播接口
live.liveDetail = { url: api + '/custer/live/detail', method: 'post' }
// 直播断流接口
live.liveStatus = { url: api + '/custer/live/common/status', method: 'post' }

// 聊天室登陆接口
chat.cusLogin = { url: api + '/sso/cusUser/common/cusLogin', method: 'post' }
// 聊天室登陆接口
chat.UserInfo = { url: api + '/custer/user/getUserInfo', method: 'postinfo' }
// 聊天室融云接口
chat.getRongToken = { url: api + '/sso/user/common/getRongToken', method: 'post' }

// 专家组方 组方详情
expert.compreDetail = { url: api + '/custer/common/compre/detail', method: 'post' }
// 专家组方 专享详情页
expert.expertinfo = { url: apiII + '/findexpert/expertinfo/', method: 'postfomdata' }
// 专家详情
expert.getExpertDetail = { url: api + '/custer/common/netWorkHospital/getExpertDetail', method: 'get' }

// 店铺详情
shop.findStoreByOrganId = { url: api + '/custer/vt/dpStoreManagement/common/findStoreByOrganId', method: 'post' }

export { Auth, sales, special, shop, healthy, order, live, chat, expert, appkey }

